var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"breadcrumb",attrs:{"aria-label":"breadcrumbs"}},[_c('ul',_vm._l((_vm.breadcrumbs),function(b){return _c('li',{class:{'is-active':b.isActive || b.notClickable}},[(b.lname)?_c('router-link',{attrs:{"to":{ name: b.routeName }}},[_vm._v(_vm._s(b.lname))]):_vm._e(),_vm._v(" "),(b.dynamic)?_c('router-link',{attrs:{"to":{ name: b.routeName }}},[_vm._v(_vm._s(_vm.getDynamicBreadcrumb(b.dynamic)))]):_vm._e()],1)}))])}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../node_modules/vue-loader/lib??vue-loader-options!./src/components/breadcrumbs.vue?vue&type=template&id=7ea0463a
// module id = QeX/
// module chunks = 0